const SIZE_UNITS = {
    small: '32px',
    medium: '36px',
    large: '48px',
};

const RADIUS_UNITS = {
    small: '16px',
    in_small: '14px',
    medium: '18px',
    in_medium: '16px',
    large: '20px',
    in_large: '18px',
};

const paddingList = {
    default: '0 20px',
    fab: '0',
    extendedFab: '0 12px 0 10px',
};

type SizeUnit = keyof typeof SIZE_UNITS | string;

export const size = ({ size }: { size: SizeUnit }): string => SIZE_UNITS[size || 'medium'];
export const innerSize = ({ size }: { size: SizeUnit }): string => SIZE_UNITS[`in_${size || 'medium'}`];
export const radius = ({ radius, size }): string => {
    if (radius) {
        if (typeof radius === 'boolean' && radius) {
            return '50%';
        } else if (typeof radius === 'string') {
            return radius;
        }
    }

    const prop = radius || size || 'medium';
    return RADIUS_UNITS[prop];
};

/**
 * padding helper
 * @param variant
 * @param padding
 * @returns {string}
 * @private
 */
export const padding = ({ variant, padding }): string => {
    if (typeof padding !== 'undefined' && padding !== null) {
        return padding;
    }
    const key = variant || 'default';
    return paddingList.hasOwnProperty(key) ? paddingList[key] : paddingList.default;
};

export const variantBorder = ({ variant }): undefined | string => (variant === 'outlined' ? undefined : 'none');
